"use client";

import * as React from "react";
import Image from "next/image";
import { useTheme } from "@/providers/theme";
import { cn } from "@/lib/utils";

interface SparkleIconProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
}

const SparkleIcon = React.forwardRef<HTMLDivElement, SparkleIconProps>(
  ({ className, size = 40, ...props }, ref) => {
    const { theme } = useTheme();

    // For Lottie to GIF: https://lottiefiles.com/lottie-to-gif
    // For Lottie color changes: https://editor.lottiefiles.com
    const lightGif = "/icons/animated-sparkle-light.gif";
    const darkGif = "/icons/animated-sparkle-dark.gif";

    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          "flex h-full w-full items-center justify-center",
          className,
        )}
      >
        <Image
          src={theme === "dark" ? darkGif : lightGif}
          alt="Animated illustration"
          width={size}
          height={size}
          className="size-6 max-w-none"
          unoptimized
        />
      </div>
    );
  },
);

SparkleIcon.displayName = "SparkleIcon";

export default SparkleIcon;
